/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import StepNav from 'material/embeds/steps/stepnav/stepnav_container';
import EmbedUpdateCTA from 'material/embeds/embedupdatecta/embedupdatecta_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/flowcontrols/flowcontrols_styles';



/* ========== ~~~~~~~~~~ FLOW CONTROLS ~~~~~~~~~~ ========== */
const FlowControls = (props) => props.isNewEmbedFlow ?
    <StepNav handleSaveEmbed={props.handleSaveEmbed} /> :
    <EmbedUpdateCTA handleSaveEmbed={props.handleSaveEmbed} />;



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(FlowControls);
